import * as React from "react";
import Switch from "@mui/material/Switch";

interface IProps {
  name: string;
  label?: string;
  value?: any;
  checked?: boolean;
  disable?: boolean;
  changeHandler?: (event: any, value: any) => void;
}
const SwitchRadio: React.FC<IProps> = ({
  name,
  label,
  value,
  checked,
  disable,
  changeHandler,
}) => {
  return (
    <div>
      {label}
      <Switch
        aria-label={label}
        defaultValue={value}
        checked={!!checked ? checked : false}
        onChange={changeHandler}
        disabled={disable}
      />
    </div>
  );
};
export default SwitchRadio;
